<app-header-list titulo="Indivíduos"/>

<ion-content [fullscreen]="true">
  <p-table [lazy]="true"  (onLazyLoad)="load($event)" #dt1 styleClass="p-datatable-striped" sortMode="multiple"
             [showCurrentPageReport]="true" responsiveLayout="scroll"
             [multiSortMeta]="[{field: 'dataHora', order: -1}]"
             currentPageReportTemplate="{first}-{last}/{totalRecords}"
             [pageLinks]="0" [totalRecords]="total"
             [rows]="100" [paginator]="true"  dataKey="id" [value]="entidades">
      <ng-template pTemplate="header">
        <tr style="vertical-align: top">
          <th pSortableColumn="dataHora"> Data<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="dataHora"></p-sortIcon>
              <p-columnFilter display="menu" type="date" field="dataHora"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="taxon.grupo"> Grupo<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="taxon.grupo"></p-sortIcon>
              <p-columnFilter matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                              [showAddButton]="false" field="taxon.grupo">
                <ng-template pTemplate="filter" let-gruposSelecionados let-filter="filterCallback">
                  <p-multiSelect [ngModel]="gruposSelecionados"
                                 [options]="grupos" (onChange)="filter($event.value)"
                                 [filter]="false">
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="taxon.name"> Nome Científico<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="taxon.name"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="taxon.name"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="taxon.commonNames"> Nomes Comuns<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="taxon.commonNames"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="taxon.commonNames"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="taxon.status"> Estado Conser.<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="taxon.status"></p-sortIcon>
              <p-columnFilter display="status" type="text" field="taxon.status"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="municipio.nome"> Município<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="municipio.nome"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="municipio.nome"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="microRH.nome"> MicroRH<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="microRH.nome"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="microRH.nome"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="bioma.nome"> Bioma<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="bioma.nome"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="bioma.nome"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="fitofisionomia.nome"> Fitofisionomia<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="fitofisionomia.nome"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="fitofisionomia.nome"></p-columnFilter>
            </div>
          </th>


        </tr>
      </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td><a routerLink="edit/{{item.id}}">{{item.dataHora | date   : 'dd/MM/yy HH:mm' }}</a></td>
        <td><a routerLink="edit/{{item.id}}">{{item.taxon?.grupo}}</a></td>
        <td><a routerLink="edit/{{item.id}}">{{item.taxon?.name}}</a></td>
        <td><a routerLink="edit/{{item.id}}">{{item.taxon?.commonNames}}</a></td>
        <td><a routerLink="edit/{{item.id}}">{{getStatusConservacao(item.taxon?.status)}}</a></td>
        <td><a routerLink="edit/{{item.id}}">{{item.municipio?.nome}} {{item.municipio?.uf}}</a></td>
        <td><a routerLink="edit/{{item.id}}">{{item.microRH?.nome}}</a></td>
        <td><a routerLink="edit/{{item.id}}">{{item.bioma?.nome}}</a></td>
        <td><a routerLink="edit/{{item.id}}">{{item.fitofisionomia?.nome}}</a></td>
      </tr>
    </ng-template>

    </p-table>
<!--  <ion-fab slot="fixed"  vertical="bottom" horizontal="end">-->
<!--    <ion-fab-button routerLink="new" color="success">-->
<!--      <ion-icon  name="add"></ion-icon>-->
<!--    </ion-fab-button>-->
<!--  </ion-fab>-->
</ion-content>

<app-rodape [exibirBotoes]="false"/>
